module.exports = function() {
  return new Worker(__webpack_public_path__ + "f63b8c93121f9af8e95b.worker.js");
};